<template>
    <q-table
        :title="title"
        :data="data"
        :columns="columns"
        :filter="filterAux"
        :pagination.sync="paginationAux"
        :rows-per-page-options="[2, 10, 20, 50, 100]"
        :loading="loading"
        binary-state-sort
        row-key="class_id"
        flat
        @request="request"
    >
        <template v-slot:top>
            <slot name="top" />
        </template>
        <template v-slot:body-cell-title="props">
            <q-td key="title" :props="props">
                <router-link
                    :to="{
                        name: 'CourseDetails',
                        params: { id: props.row.courses.id },
                    }"
                    ><span class="text-secondary">
                        {{ JSON.parse(props.row.courses.title)[locale.key] }}
                    </span></router-link
                >
            </q-td>
        </template>
        <template v-slot:body-cell-start_date="props">
            <q-td key="start_date" :props="props">
                {{ formatDate(props.row.start_date) }}
            </q-td>
        </template>
        <template v-slot:body-cell-end_date="props">
            <q-td key="end_date" :props="props">
                {{ formatDate(props.row.end_date) }}
            </q-td>
        </template>
        <template v-slot:body-cell-trainers="props">
            <q-td key="trainers" :props="props">
                {{ getTrainers(props.row.trainers) }}
            </q-td>
        </template>
        <template v-slot:body-cell-vacancies="props">
            <q-td key="vacancies" :props="props">
                {{ props.row.vacancies - props.row.trainee_number }} /
                {{ props.row.vacancies }}
            </q-td>
        </template>
    </q-table>
</template>

<script>
import formatDate from '@/helpers/date-time'
import store from '@/store'

export default {
    name: 'ClassTable',

    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: null,
        },
        filter: {
            type: Object,
            default: () => {},
        },
        columns: {
            type: Array,
            default: () => [],
        },
        data: {
            type: Array,
            default: () => [],
        },
        pagination: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            paginationAux: {},
            filterAux: {},
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },
    },

    watch: {
        pagination(value) {
            this.paginationAux = value
        },

        filter(value) {
            this.filterAux = value
        },
    },

    mounted() {
        this.paginationAux = this.pagination
        this.filterAux = this.filter
    },

    methods: {
        request(props) {
            const { page, rowsPerPage, sortBy, descending } = props.pagination
            const filter = props.filter

            this.paginationAux.page = page
            this.paginationAux.rowsPerPage = rowsPerPage
            this.paginationAux.sortBy = sortBy
            this.paginationAux.descending = descending

            this.filterAux = filter

            this.$emit('request', this.paginationAux, this.filterAux)
        },

        dateMaskFormat() {
            return this.locale &&
                this.locale.definition &&
                this.locale.definition.dateFormat
                ? this.locale.definition.dateFormat
                : 'DD/MM/YYYY'
        },

        formatDate(value) {
            return value
                ? formatDate.fromServerToUxString(
                      value,
                      'date',
                      this.dateMaskFormat()
                  )
                : null
        },

        getTrainers(trainers) {
            return trainers
                ? trainers.map((trainer) => trainer.user.first_name).join(' | ')
                : ''
        },
    },
}
</script>
